<template>
  <div class="setting-container">
    <div class="setting-operate">
      <button class="operate-spe3" :class="{'operate-spe1':isA,'es1':isEs,'po1':isPo}" @click="changeStype1">
        <span>{{$t('staticSettings')}}</span>
      </button>
      <button class="operate-spe3" :class="{'operate-spe1':isB,'po1':isFr}" @click="changeStype2" v-show="isM">
        <span>{{$t('dataSource')}}</span>
      </button>
    </div>
    <el-card class="setting-main">
       <router-view></router-view>
    </el-card>
  </div>
</template>

<script>
  import auth from '../auth/auth'
  export default{
    data(){
      return{
        isA:'true',
        isB:'false',isM:true,isEs:false,isPo:false,isFr:false,
      }
    },
    mounted(){
      this.isA = (this.$route.path ==='/setting')?true:false;
      this.isB = (this.$route.path ==='/dateView2')?true:false;
      let uid = 0;
      this.isM = (sessionStorage.getItem('userType')==='M')?false:true;

      let lang = sessionStorage.getItem('language');
      this.isEs= (lang==='es')?true:false;
      this.isPo= (lang==='po')?true:false;
      this.isFr= (lang==='fr')?true:false;
      if(sessionStorage.getItem('userType')!=='P'){
         uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        uid = parseInt(sessionStorage.getItem('uid'));
      }
      auth.getSettingData(this,uid);
     // auth.getSessions(this,uid);
    },
    methods:{
      changeStype1(){
        this.isA = true;
        this.isB = false;
        this.$router.push('setting');
      },
      changeStype2(){
        this.isB = true;
        this.isA = false;
        this.$router.push('dateView2');
      },
      back(){
        this.$router.push('/PatientList');
      },
    },
  }
</script>

<style scoped>
  .setting-container{
    height:100%;
    width:100%;
    margin:0 auto;
    background:#fafbfc;
  }
  .setting-operate{
    width:93%;
    margin: 0 auto;
  }
  .setting-operate button{
    border: 1px solid #a3a3a3;
    outline: none;
    border-radius:100px;
    font-family:SFUIText-Regular;
    box-shadow:0 3px 4px 0 #e8f3ff;
    font-size:16px;
    color:#282828;
    height:30px;
    line-height: 30px;
    letter-spacing:-0.39px;
    text-align:center;
    margin-right:2.2%;
    margin-top: 20px;
    background:#ffffff;
    width:160px;
    cursor: pointer;
  }
  .setting-operate .operate-spe1{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#ffffff;
    border:none;
  }
  .setting-operate .operate-spe3{
    margin-left: 1.5%;
    width:200px;
  }
  .setting-operate span{
    margin:0 20px;
  }
  .setting-operate .es1{
    width:220px;
  }
  .es1 span{
    margin:0;
  }
  .setting-operate .po1{
    width:220px;
  }

  .setting-main{
    margin:10px auto 0;
    width: 97%;
    *height:820px;
    background:#fff;
    box-shadow:0 3px 4px 0 rgba(175,175,175,0.50);
    border-radius:6px;
    border:none;
  }

</style>



// WEBPACK FOOTER //
// chartSetting.vue?0e2b8ad2